/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styled tab
 *
 * @file BookAndPageTabStyle.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';

import { THEME_DARK } from '../../common/constants';

const BookAndPageTabStyle = withStyles((theme) => ({
  root: {
    borderRadius: 41,
    margin: 4,
    minHeight: 32,
    minWidth: 74
  },
  textColorPrimary: {
    color: theme.color.textPrimary,
    fontFamily: 'Hind',
    fontSize: 14,
    fontStyle: 'normal'
  },
  selected: {
    background: `${theme.color.background} !important`,
    border: theme.activeTheme === THEME_DARK ? `1px solid ${theme.color.activePrimary}` : 'none',
    boxShadow: '0px 7px 8px rgba(0, 0, 0, 0.05)',
    color: `${theme.color.activePrimary} !important`,
    fontWeight: 'bold'
  }
}))(Tab);

export default BookAndPageTabStyle;
